<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reload="resetPage"
        @openEditFormDialog="openEditFormDialog"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <EditFormDialog
      :visible.sync="editFormDialogOptions.visible"
      :title="editFormDialogOptions.title"
      :shippingMarkCode="editFormDialogOptions.code"
      :disabled="editFormDialogOptions.disabled"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import BasePage from '@/mixins/base-pagination'
import EditFormDialog from '../edit-form/dialog.vue'
export default {
  components: { PageHeader, PageMain, EditFormDialog },
  mixins: [BaseTable, BasePage],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .shippingMarkListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, code = '' }) {
      const types = {
        edit: this.$l('dialog_title_edit_mark_info') || '编辑唛头信息',
        add: this.$l('dialog_title_add_mark_info') || '增加唛头信息',
        detail: this.$l('dialog_title_mark_info_detail') || '唛头信息详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        code: code,
        disabled: type === 'detail',
      }
    },
  },
}
</script>
